import React from 'react'
import skillData from '../skills/skillData.json';

const SkillsDescriptions = () => {
    const SkillDescriptions = skillData.map((data, index) => (
        <p>{data.description}</p>
    ));
    return SkillDescriptions;
}

export default SkillsDescriptions